import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../services/httpService";
import {
  getServicesByPharmacyIdUrl,
  addRooms,
  updateRooms,
  getPharmaciesByCompanyIdUrl,
  getCompanyPharmaciesCountUrl
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";

const initialState = {
  isLocationLoading: false,
  locationPharmacyData: [],
  lastLocationAddedUpdated: null,
  generalById: [],
  isPharmacyServiceLoading: false,
  allPharmacies: [],
  companyPharmaciesCount: 0,
};

export const getServicesByPharmacyIdData = createAsyncThunk(
  "setting/getServicesByPharmacyIdData",
  async (pharmacyId, thunkAPI) => {
    const urlToGet = getServicesByPharmacyIdUrl(pharmacyId);
    const respData = await httpGet(urlToGet);
    return respData?.services;
  },
);

export const addRoomtData = createAsyncThunk(
  "setting/addRoomtData",
  async (data, thunkAPI) => {
    const respData = await httpPost(addRooms(), data);
    return respData;
  },
);
export const updateRoomtData = createAsyncThunk(
  "setting/updateRoomtData",
  async (data, thunkAPI) => {
    const respData = await httpPost(updateRooms(), data);
    return respData;
  },
);

export const getPharmaciesByCompanyIdData = createAsyncThunk(
  "setting/getPharmaciesByCompanyIdData",
  async (companyId, thunkApi) => {
    const urlToGet = getPharmaciesByCompanyIdUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getCompanyPharmaciesCountData = createAsyncThunk(
  "setting/getCompanyPharmaciesCountData",
  async (companyId, thunkApi) => {
    const urlToGet = getCompanyPharmaciesCountUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setIsLocationLoading: (state, action) => {
      state.isLocationLoading = action?.payload || false;
    },
    setCompanyPharmaciesData: (state, action) => {
      state.companyPharmaciesData = action?.payload || [];
    },
    resetLocationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getServicesByPharmacyIdData.pending, (state) => {
        state.isLocationLoading = true;
        state.locationPharmacyData = null;
      })
      .addCase(getServicesByPharmacyIdData.fulfilled, (state, action) => {
        state.isLocationLoading = false;
        state.locationPharmacyData = action?.payload;
      })
      .addCase(getServicesByPharmacyIdData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isLocationLoading = false;
        state.locationPharmacyData = null;
      })
      .addCase(addRoomtData.pending, (state) => {
        state.isLocationLoading = true;
        state.lastLocationAddedUpdated = null;
      })
      .addCase(addRoomtData.fulfilled, (state, action) => {
        state.isLocationLoading = false;
        state.lastLocationAddedUpdated = action?.payload;
      })
      .addCase(addRoomtData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isLocationLoading = false;
        state.lastLocationAddedUpdated = null;
      })
      .addCase(updateRoomtData.pending, (state) => {
        state.isLocationLoading = true;
        state.lastLocationAddedUpdated = null;
      })
      .addCase(updateRoomtData.fulfilled, (state, action) => {
        state.isLocationLoading = false;
        state.lastLocationAddedUpdated = action?.payload;
      })
      .addCase(updateRoomtData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isLocationLoading = false;
        state.lastLocationAddedUpdated = null;
      })
      .addCase(getPharmaciesByCompanyIdData.pending, (state) => {
        state.isPharmacyServiceLoading = true;
      })
      .addCase(getPharmaciesByCompanyIdData.fulfilled, (state, action) => {
        state.isPharmacyServiceLoading = false;
        state.allPharmacies = action?.payload || [];
      })
      .addCase(getPharmaciesByCompanyIdData.rejected, (state, action) => {
        state.isPharmacyServiceLoading = false;
        state.allPharmacies = [];
      })
      .addCase(getCompanyPharmaciesCountData.pending, (state) => {
        state.isPharmacyServiceLoading = true;
      })
      .addCase(getCompanyPharmaciesCountData.fulfilled, (state, action) => {
        state.companyPharmaciesCount = action?.payload || 0;
      })
      .addCase(getCompanyPharmaciesCountData.rejected, (state, action) => {
        state.isPharmacyServiceLoading = false;
        state.companyPharmaciesCount = 0;
      })
      ;
  },
});

// Action creators are generated for each case reducer function
export const {
  setIsLocationLoading,
  setCompanyPharmaciesData,
  resetLocationState,
} = locationSlice.actions;

export default locationSlice.reducer;
